<template>
  <div class="chat-contact">
   <!--  <v-toolbar flat dense class="chat-contact--toolbar">
      <v-text-field flat solo full-width prepend-icon="search" label="Search"></v-text-field>
    </v-toolbar> -->
    <vue-perfect-scrollbar class="chat-history--scrollbar">
      <v-divider></v-divider>
           <button type="button" class="mb-2 v-btn theme--dark primary"  @click="Enable_chechbox_butt()">
                <span v-if="!enable_chechbox_butt_var">{{'chat._select_group_'|translate}}</span>
                <span v-else>{{'general._cancel_'|translate}}</span>
           </button>
            <button v-show='selected.length>1' type="button" class="mb-2 v-btn theme--dark primary"  @click="create_group()">  
                <span >{{'chat._create_group_'|translate}}</span>
           </button>
            <input v-show='selected.length>1' class="form_checkbox" type="text"  v-model="group_title" :placeholder="$t('chat._group_name_')">

      <v-list two-line class="chat-contact--list">
        <v-subheader>{{'chat._Contacts_'|translate}}</v-subheader>
        <template v-for="(item, index) in users">
          <v-divider :key="index"></v-divider>
                <label>
                <input v-show="enable_chechbox_butt_var" class="form_checkbox" type="checkbox" :value="item.uuid" v-model="selected">
              </label>
          <v-list-tile avatar :key="item.first_name + index" :to="contactRoute(item.uuid)" >
          
            <v-list-tile-avatar color="primary" >
              <img :src="item.avatar" v-if="item.avatar">
              <span v-else class="white--text headline">{{ firstLetter(item.fullName)}}</span>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>{{item.first_name}}</v-list-tile-title>
              <v-list-tile-sub-title>{{item.last_name}}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              
            <ul class="status" v-bind:style={color:userStatusColor(item)}><li>&nbsp</li></ul>
             
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
    </vue-perfect-scrollbar>
  </div>
</template>

<script>
//import { * } from "@/api/user";
import VCircle from "@/components/circle/VCircle";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { db } from '@/api/firebaseInit';
import firebase from 'firebase';
export default {
  components: {
    VuePerfectScrollbar,
    VCircle
  },
  data() {
    return {
      Users: [],
      selected: [],
      selectAll: false,
      next_click:false,
      enable_chechbox_butt_var: false,
      conversation_id:'',
      createdById:'',
      createdBy:'',
      participants:[],
      participants_search:[],
      group_title:''
    };
  },
  mounted() {   
   // this.fetchUsers();
  },
  created() {
    //  this.fetchUsers();
          if(firebase.auth().currentUser) {
        this.createdById = firebase.auth().currentUser.uid
        this.createdBy = firebase.auth().currentUser.displayName
        if(!this.createdBy) {
          this.createdBy = firebase.auth().currentUser.email
        }
      }
  },
  computed: {
    users(){
    
      let users =  this.$store.getters.users;
      return users;
    }
  },
    watch: {
   users(){
    
      let users =  this.$store.getters.users;
      return users;
    }
  }, 
  methods: {

   create_group () {
      
      this.participants=[];
      this.participants_search=[];
      var new_conversation= true;
      var conversation_id_exist = ''

      this.participants_search.push(this.createdById)
      for(var k=0;k<this.selected.length;k++){
      this.participants_search.push(this.selected[k])
      }
     
    
    let convos = this.$store.getters.groups;
         convos = convos.filter(item => (item.type) === 'group');     

      for( var i =0;i<this.participants_search.length;i++) {
        let user = this.$store.getters.getUserById(this.participants_search[i]);
        var user_obj ={first_name:user.first_name,last_name:user.last_name,thumbnail_url:user.thumbnail_url,user_id:user.uuid}
        this.participants.push(user_obj)
      }
    
      for(var j=0;j<convos.length;j++){
        for(var p =0;p<convos[j].participants.length;p++){
          for(var s=0;s< this.participants_search.length;s++){  
          if (convos[j].participants[p].user_id === this.selected[s] ) {
            if (convos[j].participants.length == this.participants.length) { 
              new_conversation= false;
              conversation_id_exist =convos[j].uuid
              break;
            }
          }
        }
        }
        if(!new_conversation){
          break;
        }
      }

        if(new_conversation) {
         
          this.selected=[]
          this.create_group_conversation(this.participants)
        } 
         else {
              this.selected=[]
             this.$router.push({name: 'ChatMessaging', params: {uuid: conversation_id_exist}});

        }

    },


    create_group_conversation(participants) {
      const convosRef = db.collection("conversations").doc();
      const refKey = convosRef.id;
      this.conversation_id = refKey;
      
      convosRef
        .set({
          created_date: new Date(),
          entityKey: this.conversation_id,
          id: this.conversation_id,
          image_url:"default",
          last_message:"",
          last_update:new Date(),
          participants:participants,
          title:this.group_title,
          type:"group"
        })
        .then(() => {

              this.$store.dispatch('fetchConvos').then(() => {
         this.$store.dispatch('fetchMessages').then(() => {
         this.$router.push({name: 'ChatMessaging', 
        params: {uuid:  this.conversation_id,  new_convos:'true'}});  
      })
    })       
        })
        .catch(error => {
          console.error("Error adding member: ", error);
        });


    },
        Enable_chechbox_butt() {
      if (this.next_click == true) {
        this.enable_chechbox_butt_var = false;
        this.next_click = false;
      } else {
        this.enable_chechbox_butt_var = true;
        this.next_click = true;
      }
    },
       select() {
      this.selected = [];
      if (!this.selectAll) {
        for (let i in this.Events2) {
          this.selected.push(this.Events2[i].id);
        }
      }
    },


    contactRoute(id) {
      return "/chat/contact/" + id;
    },
    firstLetter(name) {
      return name.charAt(0);
    },
    userStatusColor(item) {
      return item.online ? "green" : "grey";
    }
  }
};
</script>

<style>
ul.status {
  list-style-position: outside;
   font-size: 36px;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/ChatContactList.vue